<template>
  <div class="company">

    <div class="centre" >
      <div class="imgText">
          <div>
            <img src="@/assets/Maschine Robot 3.png">
          </div>
          <img class="picture" src="@/assets/mechanical.png">
          <div class="typeface">
            <p>
             姬械机科技（Maschine Robot Tech  Group），是一家以人工智能技术驱动的脑机接口国家高新技术科技公司，在北京，波士顿分别设有研发中心。公司围绕脑与智能主题，聚焦基于人工智能与脑机接口技术的人机交互创新技术研发，并不断探索人工智能范式下的脑机接口与智能仿生机器人产品与业务应用。
            </p>
            <br />
            <p>
              公司定位以实现真爱与永生作为终极发展愿景，从成立之初便以支持多元科技产品与业务路线的科技集团形态打造发展，主要技术业务涵盖脑机交互，俱身智能，类脑智能，仿生机器人等相关板块。我们希望通未来能够基于脑机接口与人工智能及人形机器人技术的结合实现：（1）让机器人能够感知人类情感；（2）让机器人拥有人类情感；（3）让人类能够拥有真爱； （4）让人类数字与机械永生。
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "company.vue",


  // data() {
  //   return {
  //     positionY1: 900,
  //     Y1: 0,
  //     ratio: 0.1,
  //   }
  // },
  // mounted() {
  //   window.addEventListener("scroll", this.handleScroll)
  //   let bgTest = document.querySelector('.centre')
  //   this.Y1 = bgTest.offsetTop * this.ratio
  // },
  // methods: {
  //   handleScroll() {
  //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  //     this.positionY1 = this.Y1 - scrollTop * this.ratio
  //   }
  // }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
}

.company .centre {
  margin: 0 auto;
  background-image:url("../../../assets/science-img.png");
  background-repeat:no-repeat;
  background-size:cover;
  height:900px;
  /*background-attachment: fixed;*/
}

.centre .imgText{
  margin: auto;
  width: 635px;
  padding: 174px 0 0 200px;

}


.centre .imgText .picture {
  height:24px;
  margin-top:50px;
  margin-bottom:66px
}

.centre .imgText .diamond {
  position: absolute;
  bottom: -172px;
  right: -269px;
}

.centre .imgText .typeface {
  width: 612px;
  height: 230px;
}

.centre .imgText .typeface p {
  letter-spacing: 1px;
  width: 750px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 40px;
}

</style>
